import WelcomeScreenLightbox from './components/WelcomeScreenLightbox'
import {bindActionCreators} from "redux"
import {connect} from '../../redux/utils'
import { getDemoDataStage, getLoadExternalWelcomeScreen, getLoading, getShowExternalContent, getUrl } from './selectors'
import {openLightbox, closeLightbox, setShowExternalContent, setLoading} from './actions'
import $ from '../../alias/jquery'
import {WelcomeScreenFrameId} from './constants'
import assignSitePopupBridge from './SitePopupBridge'
import StateComponent from '../../StateComponent'
import { isLicenseTrial } from '../../activeLicenseInfo/selectors'
import { getFirstName, isFirstAdmin } from '../../loggedInUser/selectors'
import ClassicBridge from "../../next/ClassicBridge";

class StartupWizard extends StateComponent {
    constructor({
            $containerEl = $('body'),
            openLightbox,
            closeLightbox,
            setShowExternalContent,
            setLoading,
        }
    ) {
        super($containerEl)
        this.state = {
            loading: false,
            showExternalContent: false,
            loadExternalWelcomeScreen: false,
            url: '',
        }

        this.params = {
            openLightbox,
            closeLightbox,
            setShowExternalContent,
            setLoading,
        }

        this.onStatePropertyChanged('loading', loading => {
            if (!loading) {
                this.pageLoadingMoire.remove()
            }
        })

        this.onStatePropertyChanged('showExternalContent', showExternalContent => {
            if (showExternalContent) {
                this.lightbox.show()
            } else {
                this.lightbox.hide()
            }
        })



        this.onStatePropertyChanged('url', url => {
            this.lightbox.changeUrl(url)
        })
    }

    init() {
        this.lightbox = new WelcomeScreenLightbox({
            onCloseCallback: this.params.closeLightbox,
            iframeLoadCallback: (contentKey) => {
                this.params.setShowExternalContent(true)
                this.params.setLoading(false)

                assignSitePopupBridge(
                    window.frames[contentKey],
                    {
                        close: () => this.params.closeLightbox(false),
                        username: this.state.username,
                        isTrial: this.state.isTrial,
                        isFirstAdmin: this.state.isFirstAdmin,
                    }
                )
            },
            frameName: WelcomeScreenFrameId,
            loadExternalWelcomeScreen: true,
            showCloseButton: false,
            className: 'startupWizard'
        })
        this.lightbox.init()

        const overlays = document.createElement('div')
        overlays.className = 'atNextMount atNextOverlays'
        $('body')[0].appendChild(overlays)

        this.pageLoadingMoire = ClassicBridge.integrateFullscreenSpinner(overlays, {
            className: 'fullscreenSpinnerZindex'
        })

        this.params.openLightbox()
    }
}

export default connect(
    (state) => ({
        loading: getLoading(state),
        showExternalContent: getShowExternalContent(state),
        demoDataStage: getDemoDataStage(state),
        url: getUrl(state),
        loadExternalWelcomeScreen: getLoadExternalWelcomeScreen(state),
        username: getFirstName(state),
        isTrial: isLicenseTrial(state),
        isFirstAdmin: isFirstAdmin(state),
    }),
    dispatch => bindActionCreators({
        openLightbox,
        closeLightbox,
        setShowExternalContent,
        setLoading,
    }, dispatch)
)(StartupWizard)


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/StartupWizard.js